import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'bv-i18n';
import { linkLocalizer } from 'locale-helper';

export const TreeTypeSwitcherComponent = ({
  selectedSportId,
  treeType,
  sports,
  isGroup,
}) => {
  if (!Number.isNaN(Number(selectedSportId))) {
    if (treeType === 'in_play' && !sports.some((s) => s.hasUpcomingEvents)) {
      return null;
    }
    if (treeType === 'upcoming' && !sports.some((s) => s.hasInplayEvents)) {
      return null;
    }
  }
  return (
    <div className="inply-upcoming-events-link-wrapper">
      <a
        href={linkLocalizer(
          `/live/${isGroup ? 'group/' : ''}${selectedSportId || 'overview'}${treeType === 'in_play' ? '/upcoming' : ''}`,
        )}
        className="bvs-button is-primary is-round inply-upcoming-events-link"
      >
        {
          treeType === 'in_play'
            ? t('javascript.in_play.see_upcoming_events')
            : t('javascript.in_play.see_inplay_events')
        }
      </a>
    </div>
  );
};

TreeTypeSwitcherComponent.propTypes = {
  treeType: PropTypes.isRequired,
  sports: PropTypes.isRequired,
  selectedSportId: PropTypes.isRequired,
  isGroup: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  treeType: state.inplay.treeType,
  selectedSportId: state.inplay.selectedSportId,
});

export default connect(mapStateToProps)(TreeTypeSwitcherComponent);
